'use client';
import React from 'react';
import Tooltip from '@/components/atoms/Tooltip/Tooltip';
import DropDown from '@/components/atoms/DropDown';
import { BsTwitterX } from 'react-icons/bs';
import { FaFacebook } from 'react-icons/fa6';
import { TbWorldWww } from 'react-icons/tb';
import { TiSocialLinkedinCircular } from 'react-icons/ti';
import { IoLogoWhatsapp } from 'react-icons/io';
import { IC_SHARE } from '@/assets/icons';
import { useAlert } from '@/contexts/AlertProvider';

function fallBackCopyTextToClipboard(text, alert) {
	// Create a new text area element
	const textArea = document.createElement('textarea');

	// Set its value to the text you want to copy
	textArea.value = text;

	// Make it not editable and not visible
	textArea.setAttribute('readonly', '');
	textArea.style.position = 'absolute';
	textArea.style.left = '-9999px';

	// Append it to the body
	document.body.appendChild(textArea);

	// Select the text inside
	textArea.select();

	// Try to execute the copy command
	try {
		document.execCommand('copy');
		alert.success({
			message: 'Product link copied to clipboard',
			provider: 'toast'
		});
	} catch (err) {
		console.error('Fallback: Oops, unable to copy', err);
	}

	// Remove the text area now that we're done with it
	document.body.removeChild(textArea);
}

function copyTextToClipboard(text, alert) {
	if (!navigator.clipboard) {
		fallBackCopyTextToClipboard(text, alert);
		return;
	}
	navigator.clipboard.writeText(text).then(
		function () {
			alert.success({
				message: 'Product link copied to clipboard',
				provider: 'toast'
			});
		},
		function (err) {
			console.error('Async: Could not copy text: ', err);
		}
	);
}

const DropDownWrapper = () => {
	const alert = useAlert();
	return (
		<DropDown
			itemClassName='d-flex items-center gap-10 p-10'
			overlay={[
				{
					key: '1',
					label: 'Copy link',
					icon: <TbWorldWww size={24} />,
					onClick: () => {
						copyTextToClipboard(window.location.href, alert);
					}
				},
				{
					key: '2',
					label: 'Facebook',
					icon: <FaFacebook size={24} style={{ color: '#3b5998' }} />,
					onClick: () => {
						window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`, '_blank');
					}
				},
				{
					key: '3',
					label: 'Whatsapp',
					icon: <IoLogoWhatsapp size={24} style={{ color: '#25D366' }} />,
					onClick: () => {
						window.open(`https://api.whatsapp.com/send?text=${window.location.href}`, '_blank');
					}
				},
				{
					key: '4',
					label: 'Twitter',
					icon: <BsTwitterX size={24} style={{ color: 'black' }} />,
					onClick: () => {
						window.open(`https://twitter.com/intent/tweet?text=${window.location.href}`, '_blank');
					}
				},
				{
					key: '5',
					label: 'Linkedin',
					icon: <TiSocialLinkedinCircular size={24} style={{ color: '#0e76a8' }} />,
					onClick: () => {
						window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`, '_blank');
					}
				}
			]}
			placement='bottomRight'>
			<Tooltip content={'Share'}>
				<IC_SHARE />
			</Tooltip>
			<></>
		</DropDown>
	);
};

export default DropDownWrapper;
